var exports = {
  "k": "defaultStyles__JMYtQE",
};

module.exports = exports;
